import type { IPropertyObject } from '../shared/property-object';
import type { IPaymentMethodType, IPaymentRecord } from './payment';

// ✅ erasableSyntaxOnly-friendly replacements

export const BillStatus = {
  Paid: 'paid',
  Unpaid: 'unpaid',
  Overdue: 'overdue',
  Pending: 'pending',
} as const;

export type BillStatus = (typeof BillStatus)[keyof typeof BillStatus];

export const BillFrequency = {
  Weekly: 'weekly',
  BiWeekly: 'biweekly',
  Monthly: 'monthly',
  SemiAnnually: 'semiannually',
  Annually: 'annually',
  Quarterly: 'quarterly',
} as const;

export type BillFrequency = (typeof BillFrequency)[keyof typeof BillFrequency];

/**
 * Numeric enum replacement:
 * - you still get the same numeric values (0..6)
 * - plus a union type of those numbers
 */
export const DaysOfWeek = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
} as const;

export type DaysOfWeek = (typeof DaysOfWeek)[keyof typeof DaysOfWeek];

export type FrequencyInput = {
  frequency: BillFrequency;
  month?: string | null;
  startDate?: number | null; // optional, for biweekly rhythm locking
};

export const BillUtilityType = {
  Electricity: 'electricity',
  Water: 'water',
  Gas: 'gas',
  Internet: 'internet',
  Phone: 'phone',
  Cable: 'cable',
  Trash: 'trash',
  Sewer: 'sewer',
  Heating: 'heating',
  Cooling: 'cooling',
  Other: 'other',
} as const;

export type BillUtilityType = (typeof BillUtilityType)[keyof typeof BillUtilityType];

export interface IUtility extends IPropertyObject {
  utilityType: BillUtilityType;
  frequency: FrequencyInput;
  payeeID?: string | null;
  account?: string | null;
  lastPayment?: IPaymentRecord | null;
  dueDate?: number | null; // actual duo date for one time payment
  status?: BillStatus | null;
  paymentMethod?: IPaymentMethodType | null;
}
